import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import SubscriptionModal from './SubscriptionModal';
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [clients, setClients] = useState([]);
  const [filter, setFilter] = useState('');
  const [filtercriteria, setFilterCriteria] = useState('email');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedUser, setSelectedUser] = useState(null);
  const logged_in_user_email = sessionStorage.getItem("userEmail");

  useEffect(() => {
    fetchClientDataFromDB();
  }, []);

  const fetchClientDataFromDB = () => {
    setClients([]);
    const url = 'https://cust.3dmu.prototechsolutions.com/prod/customer/subscription/getClientSubscriptionData';

    axios.get(url, {
      headers: { 'Content-Type': 'application/json' },
    })
      .then(response => {
        const data = response.data.body
          ? JSON.parse(response.data.body)
          : response.data;
        setClients(data);
      })
      .catch(err => {
        console.error('Fetch error:', err);
        alert('You have no privilege to perform this operation');
      });
  };

  const getDateFormate = (dateVal) => {
    if (!dateVal) return "Not Provided";
    const d = new Date(dateVal);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const onSearchCriteriaSelection = (e) => setFilterCriteria(e.target.value);
  const filterData = (e) => setFilter(e.target.value);

  const handleAddSubscription = (user) => {
    const latestSubscription = user.subscriptions?.[0];

    const newSelectedUser = {
      client_id: user.client_id,
      name: user.name,
      email: user.email,
      organization_name: user.organization_name,
      ...(latestSubscription || {})
    };

    setSelectedUser(newSelectedUser);
    setModalMode('add');
    setModalOpen(true);
  };

  const handleModalSubmit = async (formData) => {
    // Helper to strip time & return local date-only object
    const toLocalDate = (date) =>
      new Date(date.getFullYear(), date.getMonth(), date.getDate());

    // Helper to format YYYY-MM-DD
    const formatDate = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
        date.getDate()
      ).padStart(2, "0")}`;

    const msInDay = 1000 * 60 * 60 * 24;

    const subscribedDate = new Date(formData.subscribed_on);
    const expiryDate = new Date(formData.expirydate);

    // Normalize both dates to remove time-of-day influence
    const start = toLocalDate(subscribedDate);
    const end = toLocalDate(expiryDate);

    const formattedSubscribedOn = formatDate(start);
    const formattedExpiryDate = formatDate(end);

    const timeperiod = Math.round((end - start) / msInDay) + 1; // inclusive

    let updatedFormData;
    if (modalMode === 'edit') {
      updatedFormData = {
        plan: formData.plan,
        type: formData.type,
        comment: formData.comment,
        tokens: Number(formData.tokens) || 0,
        available_tokens: Number(formData.available_tokens) || 0,
        subscribed_on: formattedSubscribedOn,
        expirydate: formattedExpiryDate,
        modified_by: logged_in_user_email,
      };
    } else {
      updatedFormData = {
        ...formData,
        subscribed_on: formattedSubscribedOn,
        expirydate: formattedExpiryDate,
        timeperiod,
        tokens: Number(formData.tokens) || 0,
        available_tokens: Number(formData.tokens) || 0,
        expired: false,
        added_by: logged_in_user_email
      };
    }

    try {
      const url =
        modalMode === 'edit'
          ? `http://endpoint_url/api/subscription/${formData.tid}` //not being used currently
          : "https://cust.3dmu.prototechsolutions.com/prod/customer/subscription/addSubscription";

      const method = modalMode === 'edit' ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedFormData),
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      await response.json();
      alert(modalMode === 'edit' ? 'Subscription updated successfully!' : 'Subscription added successfully!');
      fetchClientDataFromDB();
      setModalOpen(false);
    } catch (error) {
      console.error('Error submitting subscription:', error);
      alert('Failed to submit subscription. Please try again.');
    }
  };

  // Columns for clients (main table)
  const clientColumns = [
    { name:  <span style={{ fontWeight: "bold" }}>Name</span>, selector: row => row.name, sortable: true },
    {
      name: <span style={{ fontWeight: "bold" }}>Client ID</span>,
      selector: row => row.client_id,
      sortable: true,
      cell: row => (
        <span style={{ fontWeight: "bold", color: "#007bff" }}>{row.client_id}</span>
      )
    },
    { name: <span style={{ fontWeight: "bold" }}>Email</span>, selector: row => row.email, sortable: true },
    { name: <span style={{ fontWeight: "bold" }}>Organization Name</span>, selector: row => row.organization_name, sortable: true },
    {
      name: <span style={{ fontWeight: "bold" }}>Options</span>,
      cell: row => (
        <button onClick={() => handleAddSubscription(row)} style={styles.addBtn}>Add Subscription</button>
      )
    }
  ];

  const filteredData = clients.filter(item => {
    if (!item.client_id) return false;
    if (!filter) return true;

    const value = filter.toLowerCase();
    switch (filtercriteria) {
      case 'email':
        return item.email?.toLowerCase().includes(value);
      case 'id':
        return item.client_id?.toString().toLowerCase().includes(value);
      case 'name':
        return item.name?.toLowerCase().includes(value);
      case 'api_key':
        return item.api_key?.toLowerCase().includes(value);
      default:
        return false;
    }
  });

  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem("LogInState");
    navigate("/login");
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Users</h1>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <button onClick={handleLogout} style={styles.logoutBtn}>Logout</button>
      </div>

      <div style={styles.labelsWrapper}>
        <label style={{ ...styles.label, backgroundColor: 'rgba(63, 195, 128, 0.9)' }}>Activated</label>
        <label style={{ ...styles.label, backgroundColor: 'rgba(240, 100, 100, 0.9)' }}>De-Activated</label>
        <label style={{ ...styles.label, backgroundColor: '#7a5650' }}>Un-Verified</label>
      </div>

      <div style={styles.controlsContainer}>
        <select onChange={onSearchCriteriaSelection} style={styles.select}>
          <option value='email'>Email</option>
          <option value='name'>Name</option>
          <option value='id'>Id</option>
          <option value='api_key'>API Key</option>
        </select>
        <input type='text' placeholder='Search...' onChange={filterData} style={{ ...styles.input, fontWeight: "bold" }} />
      </div>

      <div style={{ overflowX: 'auto' }}>
        <DataTable
          columns={clientColumns}
          data={filteredData}
          striped // alternating row color
          highlightOnHover
          expandableRows
          expandableRowsComponent={({ data }) => (
            <div style={{ display: "flex", justifyContent: "center", margin: "20px 40px" ,overflowX: "auto"}}>
              <div style={{
                width: "80%",
                background: "#f9f9ff",
                padding: "40px",
                borderRadius: "18px",
                boxShadow: "0 8px 18px rgba(0, 0, 0, 0.15)",
                overflowX: "auto"
              }}>

                <h3 style={{ marginBottom: "20px", textAlign: "center", fontSize: "20px", color: "#333" }}>
                  Subscriptions History (Total Subscriptions : {data.subscriptions?.length || 0})
                </h3>

                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "center",
                    backgroundColor: "#f9f9ff" // light bluish-gray background for contrast
                  }}>
                    <thead>
                      <tr style={{ backgroundColor: "#e5e6e7ff", color: "#333" }}>
                        <th style={styles.th}>Subscription Plan</th>
                        <th style={styles.th}>Subscription Type</th>
                        <th style={styles.th}>Start Date</th>
                        <th style={styles.th}>Expiry Date</th>
                        <th style={styles.th}>Time Period</th>
                        <th style={styles.th}>Expired</th>
                        <th style={styles.th}>Expired On</th>
                        <th style={styles.th}>Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.subscriptions?.length > 0 ? (
                        data.subscriptions.map((sub, idx) => (
                          <tr
                            key={idx}
                            style={{
                              backgroundColor: sub.expired ? "#881f1f4f" : "#a3d6a3ff"
                            }}
                          >
                            <td style={styles.td}>{sub.plan || "Do not have any subscription"}</td>
                            <td style={styles.td}>{sub.type || "Do not have any subscription"}</td>
                            <td style={styles.td}>{sub.subscribed_on ? getDateFormate(sub.subscribed_on) : "-"}</td>
                            <td style={styles.td}>{sub.expirydate ? getDateFormate(sub.expirydate) : "-"}</td>
                            <td style={styles.td}>{sub.timeperiod ? `${sub.timeperiod} days` : "0"}</td>
                            <td style={{ ...styles.td, fontWeight: "bold", color: sub.expired ? "black" : "black" }}>
                              {sub.expired ? "true " : "false "}
                            </td>
                            <td style={styles.td}>{sub.expired_on ? getDateFormate(sub.expired_on) : "-"}</td>
                            <td style={{ ...styles.td}}>{sub.comment}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center", color: "gray", padding: "15px" }}>
                            No subscriptions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )} pagination
        />
      </div>

      <SubscriptionModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleModalSubmit}
        initialData={selectedUser}
        mode={modalMode}
      />
    </div>
  );
};

const styles = {
  container: { padding: '20px', fontFamily: 'Arial, sans-serif' },
  heading: { fontSize: '24px', marginBottom: '10px' },
  th: {
    padding: "12px",
    fontWeight: "600",
    borderBottom: "2px solid #1a1818ff"
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #d8cdcdff"
  },
  logoutBtn: {
    padding: "10px 20px",
    backgroundColor: "#ff4d4f",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer"
  },
  labelsWrapper: { display: 'flex', gap: '10px', marginBottom: '20px' },
  label: {
    color: '#ffffffff', padding: '5px 15px', borderRadius: '5px',
    fontSize: '14px', whiteSpace: 'nowrap',
  },
  controlsContainer: {
    display: 'flex', gap: '10px', justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  select: { padding: '8px', fontSize: '14px', minWidth: '120px' },
  input: { padding: '8px', fontSize: '14px', minWidth: '200px' },
  addBtn: {
    padding: "6px 12px", backgroundColor: "#007bff", color: "#fff",
    border: "none", borderRadius: "4px", cursor: "pointer"
  }
};

export default Dashboard;
